<template>
    <div>
        <forms
            :settings="settings"
            @onFormButtonClick="onFormButtonClick"
            @onInput="onInput"
        >
        </forms>
    </div>
</template>

<script>
import Forms from "../../../../components/form/Forms";
import axios from "axios";
import toastr from "toastr";
export default {
    name: "SkupTemaForma",
    components: { Forms },
    props:{
        disabled:{
            type: Boolean,
            default: false
        },
        id:{
            default: null
        },
        modal:{
            type: Boolean,
            default: false
        },
        action: {
            type: String
        }
    },
    data(){
        return {
            settings: {},
            errors: {},
            route: '/skupovi/' + this.$route.params.skup_id + '/suorganizatori',
            url: 'skup-suorganizator',
            data: {},
            skup_id: this.$route.params.skup_id,


            vrste_suorganizatora_select: [],
            suorganizatori_select: []
        }
    },

    methods: {



        async fetctVrsteSuorganizatora(){
            let vm = this
            const response = await axios.get(process.env.VUE_APP_API_URL + 'vrsta-suorganizatora' )
            return response.data.data.map( function( item ) {
                vm.vrste_suorganizatora_select.push(
                    {
                        key: item.id.toString(),
                        value: item.naziv
                    }
                )
            } )
        },

        getVrstaSuorganizatora(id) {
            return this.vrste_suorganizatora_select.find( item => item.key === id )
        },

        async fetchSuorganizatori(){
            let vm = this
            const response = await axios.get(process.env.VUE_APP_API_URL + 'suorganizator' )
            return response.data.data.map( function( item ) {
                vm.suorganizatori_select.push(
                    {
                        key: item.id.toString(),
                        value: item.naziv
                    }
                )
            } )
        },

        getSuorganizator( id ){
            return this.suorganizatori_select.find( item => item.key === id )
        },

        async init(){

            let vm = this

            await vm.fetctVrsteSuorganizatora()
            await vm.fetchSuorganizatori()

            if ( vm.action === 'edit' || vm.action === 'show' ){

                axios.get( process.env.VUE_APP_API_URL + vm.url + '/' + vm.id )
                    .then( function ( response ) {
                        vm.data['skup_id'] = response.data.skup_id.toString()
                        vm.data['vrsta_suorganizatora_id'] = response.data.vrsta_suorganizatora_id.toString()
                        vm.data['suorganizator_id'] = response.data.suorganizator_id.toString()

                        vm.$emit( 'returnData', response.data )
                        vm.setupForm()
                    } )
                    .catch( function ( error ) {
                        if(error instanceof Error) {
                            console.log( 'Error: ' . error);
                        } else {
                            console.log( 'Unexpected response: ' . error);
                        }
                    } )

            } else if ( vm.action === 'create' ) {
                vm.data = {}
                vm.setupForm()
            } else {
                return
            }
        },

        setupForm(){

            let vm = this;

            vm.buttons = []

            let button_cancel = {
                id: 'cancel',
                title: 'Odustani',
                type: 'warning',
                action: 'redirect', // request
                config: {
                    url: vm.route + ( vm.action === 'edit' ? ( '/' + vm.id) : '' )
                }
            }

            let button_delete = {
                id: 'delete',
                title: 'Obriši',
                type: 'danger',
                action: 'request',
                config: {
                    method: 'DELETE',
                    url: process.env.VUE_APP_API_URL + vm.url + '/' + vm.id
                }
            }

            let button_edit = {
                id: 'edit',
                title: 'Uredi',
                type: 'success',
                action: 'redirect',
                config: {
                    url: vm.route +  '/' + vm.id +'/edit'
                }
            }

            let button_save = {
                id: 'save',
                title: 'Spremi',
                type: 'primary',
                action: 'request',
                config: {
                    method: 'POST',
                    url: process.env.VUE_APP_API_URL + vm.url
                }
            }

            let button_update = {
                id: 'update',
                title: 'Spremi',
                type: 'primary',
                action: 'request',
                config: {
                    method: 'PUT',
                    url: process.env.VUE_APP_API_URL + vm.url + '/' + vm.id
                }
            }

            let buttons = []


            if( vm.action === 'edit' ){
                buttons.push( button_cancel)
                buttons.push( button_update)
            } else if( vm.action === 'show' ) {
                buttons.push( button_cancel )
                buttons.push( button_delete )
                buttons.push( button_edit )
            }
            else if ( vm.action === 'create' ) {
                buttons.push( button_cancel )
                buttons.push( button_save )
            } else {
                return
            }

            let inputs = []


            let skup_id_input = {
                name: 'skup_id',
                type: 'hidden',
                value: vm.skup_id,
                disabled: vm.disabled,
                config: {
                    hidden:true
                }
            }
            inputs.push( skup_id_input )



            let vrsta_suorganizatora_id_input = {
                name: 'vrsta_suorganizatora_id',
                type: 'select',
                title: 'Vrsta suorganizatora',
                value: vm.data.vrsta_suorganizatora_id ? vm.getVrstaSuorganizatora( vm.data.vrsta_suorganizatora_id ) : '',
                width: 12,
                error: vm.errors['vrsta_suorganizatora_id'] ? vm.errors['vrsta_suorganizatora_id'] : '',
                note: '',
                explanation: '',
                placeholder: '',
                required: false,
                readonly: vm.disabled,
                disabled: vm.disabled,
                config: {
                    options: vm.vrste_suorganizatora_select,
                }
            }
            inputs.push( vrsta_suorganizatora_id_input )

            let suorganizator_id_input = {
                name: 'suorganizator_id',
                type: 'select',
                title: 'Suorganizator',
                value: vm.data.suorganizator_id ? vm.getSuorganizator( vm.data.suorganizator_id ) : '',
                width: 12,
                error: vm.errors['suorganizator_id'] ? vm.errors['suorganizator_id'] : '',
                note: '',
                explanation: '',
                placeholder: '',
                required: false,
                readonly: vm.disabled,
                disabled: vm.disabled,
                config: {
                    options: vm.suorganizatori_select,
                }
            }
            inputs.push( suorganizator_id_input )

            let main_section = {
                name: ' ',
                width: 12,
                inputs: inputs
            }

            let sections = []

            sections.push( main_section )



            let settings = {
                width: 6,
                modal: false,
                tabs:[
                    {
                        name: '',
                        active: true,
                        sections: sections
                    },
                ],
                buttons: buttons
            }

            vm.settings = settings
        },

        /**
         *  on input return data
         */
        onInput( name, value ){
            if( this.data[name] !== value ){
                this.data[name] = value
            }
        },

        /**
         *  on button click
         */
        onFormButtonClick( id, action, config, data  ){

            if( id === 'save' || id === 'update' ){
                if( data.success){
                    if( id == 'save' )
                        toastr.success( 'Uspješno spremljeno!' )
                    else if ( id == 'update' )
                        toastr.success( 'Uspješno ažurirano!' )
                    this.$router.push({ path: this.route + '/' + data.data.id } )
                } else {
                    this.errors = data.messages
                    this.init()
                }
            } else if( id == 'delete' ){
                toastr.error( 'Uspješno obrisano!' )
                this.$router.push({ path: this.route } )
            }

        },
    },

    mounted() {
        this.init()
    }
}
</script>

<style scoped>

</style>
